var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('RegisterProgress',{attrs:{"step":3}}),_c('div',{staticClass:"topup-back"},[(_vm.loading)?_c('div',{staticClass:"loading",domProps:{"innerHTML":_vm._s(_vm.$t('view.back.loading'))}}):_vm._e(),(!_vm.loading)?_c('div',[_c('div',[_c('div',{staticClass:"text"},[_c('register-status')],1)])]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }